import { createStore } from "vuex";
import { config } from "vuex-module-decorators";

import { auth } from "@/store/modules/AuthModule";
import BodyModule from "@/store/modules/BodyModule";
import BreadcrumbsModule from "@/store/modules/BreadcrumbsModule";
import ConfigModule from "@/store/modules/ConfigModule";
import { menu } from "@/store/modules/MenuModule";
import { emitente } from "@/store/modules/EmitenteModule";
import { cep } from "@/store/modules/CepModule";
import { softwareHouse } from "@/store/modules/SoftwareHouseModule";
import { usuario } from "@/store/modules/UsuarioModule";
import { grupo } from "@/store/modules/GrupoModule";
import { produto } from "@/store/modules/ProdutoModule";
import { orderingCatalog } from "@/store/modules/OrderingCatalogModule";
import { orderingStore } from "@/store/modules/OrderingStoreModule";
import { orderingOrders } from "@/store/modules/OrderingOrdersModule";
import { tipoUsuario } from "@/store/modules/TipoUsuarioModule";
import { usuarioDado } from "@/store/modules/UsuarioDadoModule";
import { usuarioEndereco } from "@/store/modules/UsuarioEnderecoModule";
import { usuarioTelefone } from "@/store/modules/UsuarioTelefoneModule";
import { adicional } from "@/store/modules/AdicionalModule";
import { adicionalGrupo } from "@/store/modules/AdicionalGrupoModule";
import { adicionalGrupoItem } from "@/store/modules/AdicionalGrupoItemModule";
import { estoque } from "@/store/modules/EstoqueModule";
import { estoqueImagem } from "@/store/modules/EstoqueImagemModule";
import { estoqueVariacao } from "@/store/modules/EstoqueVariacaoModule";
import { subGrupo } from "@/store/modules/SubGrupoModule";
import { restricao } from "@/store/modules/RestricaoModule";
import { restricaoPadrao } from "@/store/modules/RestricaoPadraoModule";
import { emitenteTipoUsuario } from "@/store/modules/EmitenteTipoUsuarioModule";
import { emitenteRestricao } from "@/store/modules/EmitenteRestricaoModule";
import { emitenteRestricaoPadrao } from "@/store/modules/EmitenteRestricaoPadraoModule";
import { emitenteSoftwareHouse } from "@/store/modules/EmitenteSoftwareHouseModule";
import { cliente } from "@/store/modules/ClienteModule";
import { clienteEmail } from "@/store/modules/ClienteEmailModule";
import { clienteEndereco } from "@/store/modules/ClienteEnderecoModule";
import { clienteTelefone } from "@/store/modules/ClienteTelefoneModule";
import { transportadora } from "@/store/modules/TransportadoraModule";
import { transportadoraEmail } from "@/store/modules/TransportadoraEmailModule";
import { transportadoraEndereco } from "@/store/modules/TransportadoraEnderecoModule";
import { transportadoraTelefone } from "@/store/modules/TransportadoraTelefoneModule";
import { pedido } from "@/store/modules/PedidoModule";
import { pedidoCliente } from "@/store/modules/PedidoClienteModule";
import { pedidoEnderecoEntrega } from "@/store/modules/PedidoEnderecoEntregaModule";
import { pedidoItem } from "@/store/modules/PedidoItemModule";
import { pedidoPagamento } from "@/store/modules/PedidoPagamentoModule";
import { pedidoSubItem } from "@/store/modules/PedidoSubItemModule";
import { pedidoReceber } from "@/store/modules/PedidoReceberModule";
import ThemeModeModule from "@/store/modules/ThemeModeModule";
import { conta } from "@/store/modules/ContaModule";
import { custo } from "@/store/modules/CustoModule";
import { compartilhamento } from "@/store/modules/CompartilhamentoModule";
import { condicao } from "@/store/modules/CondicaoModule";
import { vendedor } from "@/store/modules/VendedorModule";
import { garcon } from "@/store/modules/GarconModule";
import { restauranteMotorista } from "@/store/modules/RestauranteMotoristaModule";
import { vendedorEmail } from "@/store/modules/VendedorEmailModule";
import { vendedorEndereco } from "@/store/modules/VendedorEnderecoModule";
import { vendedorTelefone } from "@/store/modules/VendedorTelefoneModule";
import { regraComissaoVendedor } from "@/store/modules/RegraComissaoVendedorModule";
import { tecnico } from "@/store/modules/TecnicoModule";
import { tecnicoEmail } from "@/store/modules/TecnicoEmailModule";
import { tecnicoEndereco } from "@/store/modules/TecnicoEnderecoModule";
import { tecnicoTelefone } from "@/store/modules/TecnicoTelefoneModule";
import { regraComissaoTecnico } from "@/store/modules/RegraComissaoTecnicoModule";
import { situacaoPedido } from "@/store/modules/SituacaoPedidoModule";
import { categoriaPedido } from "@/store/modules/CategoriaPedidoModule";
import { tipoPedido } from "@/store/modules/TipoPedidoModule";
import { localPedido } from "@/store/modules/LocalPedidoModule";
import { ordemServico } from "@/store/modules/OrdemServicoModule";
import { ordemServicoAgendamento } from "@/store/modules/OrdemServicoAgendamentoModule";
import { ordemServicoCamposAdicionais } from "@/store/modules/OrdemServicoCamposAdicionaisModule";
import { ordemServicoCliente } from "@/store/modules/OrdemServicoClienteModule";
import { ordemServicoEndereco } from "@/store/modules/OrdemServicoEnderecoModule";
import { ordemServicoEnderecoEntrega } from "@/store/modules/OrdemServicoEnderecoEntregaModule";
import { ordemServicoItem } from "@/store/modules/OrdemServicoItemModule";
import { ordemServicoServico } from "@/store/modules/OrdemServicoServicoModule";
import { ordemServicoSubItem } from "@/store/modules/OrdemServicoSubItemModule";
import { ordemServicoReceber } from "@/store/modules/OrdemServicoReceberModule";
import { ordemServicoAnexo } from "@/store/modules/OrdemServicoAnexoModule";
import { situacaoOrdemServico } from "@/store/modules/SituacaoOrdemServicoModule";
import { categoriaOrdemServico } from "@/store/modules/CategoriaOrdemServicoModule";
import { tipoOrdemServico } from "@/store/modules/TipoOrdemServicoModule";
import { atendimentoOrdemServico } from "@/store/modules/AtendimentoOrdemServicoModule";
import { motorista } from "@/store/modules/MotoristaModule";
import { motoristaEmail } from "@/store/modules/MotoristaEmailModule";
import { motoristaEndereco } from "@/store/modules/MotoristaEnderecoModule";
import { motoristaTelefone } from "@/store/modules/MotoristaTelefoneModule";
import { cidade } from "@/store/modules/CidadeModule";
import { pais } from "@/store/modules/PaisModule";
import { pedidoEndereco } from "@/store/modules/PedidoEnderecoModule";
import { pedidoAnexo } from "@/store/modules/PedidoAnexoModule";
import { pedidoItemDetCodBarras } from "@/store/modules/PedidoItemDetCodBarrasModule";
import { pedidoItemDetMetragem } from "@/store/modules/PedidoItemDetMetragemModule";
import { pedidoItemDetPesagem } from "@/store/modules/PedidoItemDetPesagemModule";
import { pedidoItemDetTipoEmbalagem } from "@/store/modules/PedidoItemDetTipoEmbalagemModule";
import { pedidoItemDetTolerancia } from "@/store/modules/PedidoItemDetToleranciaModule";
import { tipoProduto } from "@/store/modules/TipoProdutoModule";
import { aliquota } from "@/store/modules/AliquotaModule";
import { cest } from "@/store/modules/CestModule";
import { cfop } from "@/store/modules/CfopModule";
import { estoqueSt } from "@/store/modules/EstoqueStModule";
import { stUf } from "@/store/modules/StUfModule";
import { generoSped } from "@/store/modules/GeneroSpedModule";
import { servicosCnaeDet } from "@/store/modules/ServicosCnaeDetModule";
import { servicosCnaeGrupos } from "@/store/modules/ServicosCnaeGruposModule";
import { produtoTributacao } from "@/store/modules/ProdutoTributacaoModule";
import { tributacoes } from "@/store/modules/TributacoesModule";
import { ibpt } from "@/store/modules/IbptModule";
import { categoriaEstoque } from "@/store/modules/CategoriaEstoqueModule";
import { tipoEstoque } from "@/store/modules/TipoEstoqueModule";
import { configuracao } from "@/store/modules/ConfiguracaoModule";
import { labelDescricao } from "@/store/modules/LabelDescricaoModule";
import { kit } from "@/store/modules/KitModule";
import { prodKit } from "@/store/modules/ProdKitModule";
import { produtoSimulador } from "@/store/modules/ProdutoSimuladorModule";
import { produtoAdicional } from "@/store/modules/ProdutoAdicionalModule";
import { fornecedor } from "@/store/modules/FornecedorModule";
import { fornecedorEmail } from "@/store/modules/FornecedorEmailModule";
import { fornecedorEndereco } from "@/store/modules/FornecedorEnderecoModule";
import { fornecedorTelefone } from "@/store/modules/FornecedorTelefoneModule";
import { estoqueMoviOperacao } from "@/store/modules/EstoqueMoviOperacaoModule";
import { estoqueMovimentacao } from "@/store/modules/EstoqueMovimentacaoModule";
import { variacao } from "@/store/modules/VariacaoModule";
import { variacaoItem } from "@/store/modules/VariacaoItemModule";
import { modelosFaturamento } from "@/store/modules/ModelosFaturamentoModule";
import { faturamento } from "@/store/modules/FaturamentoModule";
import { nfse } from "@/store/modules/NFSeModule";
import { cte } from "@/store/modules/CTeModule";
import { controleEdicao } from "@/store/modules/ControleEdicaoModule";
import { auditoria } from "@/store/modules/AuditoriaModule";
import { restauranteAuditoria } from "@/store/modules/RestauranteAuditoriaModule";
import { restauranteCustoEntrega } from "@/store/modules/RestauranteCustoEntregaModule";
import { restauranteImpressora } from "@/store/modules/RestauranteImpressoraModule";
import { gwayAgente } from "@/store/modules/GwayAgenteModule";
import { gerenciadorNFe } from "@/store/modules/GerenciadorNFeModule";
import { chatGPT } from "@/store/modules/ChatGPTModule";
import { assistant } from "@/store/modules/AssistantModule";
import { assistantReports } from "@/store/modules/AssistantReportsModule";
import { schema } from "@/store/modules/SchemaModule";
import { consultaAvancada } from "@/store/modules/ConsultaAvancadaModule";
import { inutilizacaoNFe } from "@/store/modules/InutilizacaoNFeModule";
import { cartaCorrecaoNFe } from "@/store/modules/CartaCorrecaoNFeModule";
import { versaoTabelaIbpt } from "@/store/modules/VersaoTabelaIbptModule";
import { faturamentoItem } from "@/store/modules/FaturamentoItemModule";
import { administrador } from "@/store/modules/AdministradorModule";
import { assistenteModulos } from "@/store/modules/AssistenteModulosModule";
import { ajuda } from "@/store/modules/AjudaModule";
import release from "@/store/modules/ReleaseModule";
import { ajudaCategoria } from "@/store/modules/AjudaCategoriaModule";
import { ajudaModuloCategoria } from "@/store/modules/AjudaModuloCategoriaModule";
import { relatorios } from "@/store/modules/RelatoriosModule";
import { relatoriosModulos } from "@/store/modules/RelatoriosModulosModule";
import { recaptcha } from "@/store/modules/RecaptchaModule";
import { distribuidorMaster } from "@/store/modules/DistribuidorMasterModule";
import { distribuidor } from "@/store/modules/DistribuidorModule";
import { revenda } from "@/store/modules/RevendaModule";
import { vendedorRevenda } from "@/store/modules/VendedorRevendaModule";
import { licencaRecebivel } from "@/store/modules/LicencaRecebivelModule";
import { sessaoUsuario } from "@/store/modules/SessaoUsuarioModule";
import { atualizacaoPlano } from "@/store/modules/AtualizacaoPlanoModule";
import { agenciaBoletoLicenca } from "@/store/modules/AgenciaBoletoLicencaModule";
import { boletoLicencaRecebivel } from "@/store/modules/BoletoLicencaRecebivelModule";
import { agenciaBoleto } from "@/store/modules/AgenciaBoletoModule";
import { boletoReceber } from "@/store/modules/BoletoReceberModule";
import { bloqueioLicenca } from "@/store/modules/BloqueioLicencaModule";
import { sessaoUsuarioConnection } from "@/store/modules/SessaoUsuarioConnectionModule";
import { ticket } from "@/store/modules/TicketModule";
import { ticketMensagem } from "@/store/modules/TicketMensagemModule";
import { generator } from "@/store/modules/GeneratorModule";
import { conversao } from "@/store/modules/ConversaoModule";
import { produtoTributacaoAtualizacao } from "@/store/modules/ProdutoTributacaoAtualizacaoModule";
import { vendasCupom } from "@/store/modules/VendasCupomModule";
import { modelosVendasCupom } from "@/store/modules/ModelosVendasCupomModule";
import { gerenciadorNFCe } from "@/store/modules/GerenciadorNFCeModule";
import { gerenciadorNFSe } from "@/store/modules/GerenciadorNFSeModule";
import { gerenciadorCTe } from "@/store/modules/GerenciadorCTeModule";
import { inutilizacaoNFCe } from "@/store/modules/InutilizacaoNFCeModule";
import { modelosCTe } from "@/store/modules/ModelosCTeModule";
import { vendasCupomItem } from "@/store/modules/VendasCupomItemModule";
import { configuracaoWhiteLabel } from "@/store/modules/ConfiguracaoWhiteLabelModule";
import { compra } from "@/store/modules/CompraModule";
import { compraItem } from "@/store/modules/CompraItemModule";
import { especie } from "@/store/modules/EspecieModule";
import { receber } from "@/store/modules/ReceberModule";
import { receberAnexo } from "@/store/modules/ReceberAnexoModule";
import { pagar } from "@/store/modules/PagarModule";
import { pagarAnexo } from "@/store/modules/PagarAnexoModule";
import { receberPagamento } from "@/store/modules/ReceberPagamentoModule";
import { pagarPagamento } from "@/store/modules/PagarPagamentoModule";
import { compraDFeManifesto } from "@/store/modules/CompraDFeManifestoModule";
import { compraDFeManifestoUltimaConsulta } from "@/store/modules/CompraDFeManifestoUltimaConsultaModule";
import { compraItemRelacionamentoFornecedor } from "@/store/modules/CompraItemRelacionamentoFornecedorModule";
import { tabelaCombustiveisMonofasica } from "@/store/modules/TabelaCombustiveisMonofasicaModule";
import { cstCClassTrib } from "@/store/modules/CstCClassTribModule";
import { tabelaNcmIBSCBS } from "@/store/modules/TabelaNcmIBSCBSModule";
import { tabelaNBS } from "@/store/modules/TabelaNBSModule";
import { tabelaCodTribNac } from "@/store/modules/TabelaCodTribNacModule";
import { fechamentoVendasCupom } from "@/store/modules/FechamentoVendasCupomModule";
import { fechamentoVendasCupomControle } from "@/store/modules/FechamentoVendasCupomControleModule";
import { terminalPdv } from "@/store/modules/TerminalPdvModule";
import { pdvFinalizadora } from "@/store/modules/PdvFinalizadoraModule";
import { pdvAtualizacao } from "@/store/modules/PdvAtualizacaoModule";
import { gwayAgenteAtualizacao } from "@/store/modules/GwayAgenteAtualizacaoModule";
import { trocaCredito } from "@/store/modules/TrocaCreditoModule";
import { multiempresa } from "@/store/modules/MultiempresaModule";
import { fiscalSintegra } from "@/store/modules/FiscalSintegraModule";
import { fiscalInventario } from "@/store/modules/FiscalInventarioModule";
import { tributaAI } from "@/store/modules/TributaAIModule";
import { fiscalSpedContribuicoes } from "@/store/modules/FiscalSpedContribuicoesModule";
import { fiscalSpedFiscal } from "@/store/modules/FiscalSpedFiscalModule";
import { integracaoMercadoLivre } from "@/store/modules/IntegracaoMercadoLivreModule";
import { integracaoAmazon } from "@/store/modules/IntegracaoAmazonModule";
import { integracaoShopee } from "@/store/modules/IntegracaoShopeeModule";

config.rawError = true;

const store = createStore({
  modules: {
    auth,
    BodyModule,
    BreadcrumbsModule,
    ConfigModule,
    ThemeModeModule,
    menu,
    emitente,
    cep,
    softwareHouse,
    usuario,
    grupo,
    produto,
    orderingCatalog,
    orderingStore,
    orderingOrders,
    tipoUsuario,
    usuarioDado,
    usuarioEndereco,
    usuarioTelefone,
    adicional,
    adicionalGrupo,
    adicionalGrupoItem,
    estoque,
    estoqueImagem,
    estoqueVariacao,
    subGrupo,
    restricao,
    restricaoPadrao,
    emitenteTipoUsuario,
    emitenteRestricao,
    emitenteRestricaoPadrao,
    emitenteSoftwareHouse,
    cliente,
    clienteEmail,
    clienteEndereco,
    clienteTelefone,
    transportadora,
    transportadoraEmail,
    transportadoraEndereco,
    transportadoraTelefone,
    pedido,
    pedidoCliente,
    pedidoEnderecoEntrega,
    pedidoItem,
    pedidoPagamento,
    pedidoSubItem,
    pedidoReceber,
    conta,
    custo,
    compartilhamento,
    condicao,
    vendedor,
    garcon,
    restauranteMotorista,
    vendedorEmail,
    vendedorEndereco,
    vendedorTelefone,
    regraComissaoVendedor,
    tecnico,
    tecnicoEmail,
    tecnicoEndereco,
    tecnicoTelefone,
    regraComissaoTecnico,
    situacaoPedido,
    categoriaPedido,
    tipoPedido,
    localPedido,
    ordemServico,
    ordemServicoAgendamento,
    ordemServicoCamposAdicionais,
    ordemServicoCliente,
    ordemServicoEndereco,
    ordemServicoEnderecoEntrega,
    ordemServicoItem,
    ordemServicoServico,
    ordemServicoSubItem,
    ordemServicoReceber,
    ordemServicoAnexo,
    situacaoOrdemServico,
    categoriaOrdemServico,
    tipoOrdemServico,
    atendimentoOrdemServico,
    motorista,
    motoristaEmail,
    motoristaEndereco,
    motoristaTelefone,
    cidade,
    pais,
    pedidoEndereco,
    pedidoAnexo,
    pedidoItemDetCodBarras,
    pedidoItemDetMetragem,
    pedidoItemDetPesagem,
    pedidoItemDetTipoEmbalagem,
    pedidoItemDetTolerancia,
    tipoProduto,
    aliquota,
    cest,
    cfop,
    estoqueSt,
    stUf,
    generoSped,
    servicosCnaeDet,
    servicosCnaeGrupos,
    produtoTributacao,
    tributacoes,
    ibpt,
    categoriaEstoque,
    tipoEstoque,
    configuracao,
    labelDescricao,
    kit,
    prodKit,
    produtoSimulador,
    produtoAdicional,
    fornecedor,
    fornecedorEmail,
    fornecedorEndereco,
    fornecedorTelefone,
    estoqueMoviOperacao,
    estoqueMovimentacao,
    variacao,
    variacaoItem,
    modelosFaturamento,
    faturamento,
    nfse,
    cte,
    controleEdicao,
    auditoria,
    restauranteAuditoria,
    restauranteCustoEntrega,
    restauranteImpressora,
    gwayAgente,
    gerenciadorNFe,
    chatGPT,
    assistant,
    assistantReports,
    schema,
    consultaAvancada,
    inutilizacaoNFe,
    cartaCorrecaoNFe,
    versaoTabelaIbpt,
    faturamentoItem,
    administrador,
    assistenteModulos,
    ajuda,
    release,
    ajudaCategoria,
    ajudaModuloCategoria,
    relatorios,
    relatoriosModulos,
    recaptcha,
    distribuidorMaster,
    distribuidor,
    revenda,
    vendedorRevenda,
    licencaRecebivel,
    sessaoUsuario,
    atualizacaoPlano,
    agenciaBoletoLicenca,
    boletoLicencaRecebivel,
    agenciaBoleto,
    boletoReceber,
    bloqueioLicenca,
    sessaoUsuarioConnection,
    ticket,
    ticketMensagem,
    generator,
    conversao,
    produtoTributacaoAtualizacao,
    vendasCupom,
    modelosVendasCupom,
    modelosCTe,
    gerenciadorNFCe,
    gerenciadorNFSe,
    gerenciadorCTe,
    inutilizacaoNFCe,
    vendasCupomItem,
    configuracaoWhiteLabel,
    compra,
    compraItem,
    especie,
    receber,
    receberAnexo,
    pagar,
    pagarAnexo,
    receberPagamento,
    pagarPagamento,
    compraDFeManifesto,
    compraDFeManifestoUltimaConsulta,
    compraItemRelacionamentoFornecedor,
    tabelaCombustiveisMonofasica,
    cstCClassTrib,
    tabelaNcmIBSCBS,
    tabelaNBS,
    tabelaCodTribNac,
    fechamentoVendasCupom,
    fechamentoVendasCupomControle,
    terminalPdv,
    pdvFinalizadora,
    pdvAtualizacao,
    gwayAgenteAtualizacao,
    trocaCredito,
    multiempresa,
    fiscalSintegra,
    fiscalInventario,
    tributaAI,
    fiscalSpedContribuicoes,
    fiscalSpedFiscal,
    integracaoMercadoLivre,
    integracaoAmazon,
    integracaoShopee,
  },
});

export default store;
